import React from 'react';

import FocalImage from 'components/Layouts/Form/FormBuilder/FocalImage';

import s from './index.module.css';

function Image({ url, focalPointCoords }) {
  return (
    <div className={s.wrapper}>
      <FocalImage point={focalPointCoords} src={url} noLazyLoading />
    </div>
  );
}

export default Image;
